import { render, staticRenderFns } from "./Buoy.vue?vue&type=template&id=be68fcca&scoped=true&"
import script from "./Buoy.vue?vue&type=script&lang=js&"
export * from "./Buoy.vue?vue&type=script&lang=js&"
import style0 from "./Buoy.vue?vue&type=style&index=0&id=be68fcca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be68fcca",
  null
  
)

export default component.exports